import React from 'react';

import { cn } from 'src/component/ds/utils';

/* "Textarea - Vega" in Figma: 320x76, so min-height 76px. */
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'ds-flex ds-w-full ds-min-h-[76px] ds-resize-y ds-px-2.5 ds-py-2',
      'ds-rounded-ds ds-bg-background ds-border ds-border-input ds-shadow-ds-2xs',
      'ds-text-ds-sm ds-text-foreground placeholder:ds-text-muted-foreground',
      'focus-visible:ds-outline-none focus-visible:ds-shadow-ds-focus',
      'disabled:ds-cursor-default disabled:ds-opacity-50',
      'aria-[invalid=true]:ds-border-destructive aria-[invalid=true]:ds-shadow-none',
      'aria-[invalid=true]:focus-visible:ds-shadow-ds-focus-error',
      className
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';

export { Textarea };
